const ExportDefault = (props) => {
  return "";
};

export default ExportDefault;
